import { orchestrator } from 'satcheljs';
import { scrollToUpNext } from '../actions/internalActions';
import { onCalendarIdsUpdated } from 'owa-calendar-events-loader';
import { getShouldAutoScroll, isListCalendarCacheId } from '../selectors/agendaStoreSelectors';

export const onCalendarIdsUpdatedOrchestrator = orchestrator(
    onCalendarIdsUpdated,
    actionMessage => {
        const { eventsCacheLockId } = actionMessage;
        /** when the folderids are updated for the listCalendarCache, we scroll to the up next event, as more items have been added to the
         * list and we want to scroll the up next event back into view
         */
        const isStoredListCalendarCacheId = isListCalendarCacheId(eventsCacheLockId);
        if (isStoredListCalendarCacheId.value) {
            const agendaScenarioId = isStoredListCalendarCacheId.scenarioId;
            if (getShouldAutoScroll(agendaScenarioId)) {
                scrollToUpNext(agendaScenarioId);
            }
        }
    }
);
